import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactSelectSearchField from 'components/molecules/react-select-search-field'
import CustomerProductsBrandsApi from 'api/v2/admins/customer-products-brands-api'

const propTypes = {
  name     : PropTypes.string,
  label    : PropTypes.string,
  required : PropTypes.bool
}

const defaultProps = {
  name     : 'brand',
  label    : 'Product Brand',
  required : false
}
/**
 * @param {string} name - Formik field name
 * @param {string} label - Field Label
 * @param {bool} required - It will show required badge if it set `true`
 * @param {object} props - another props to be sent to select-search-field
 */
const FastSellProductBrandSelectField = ({
  name,
  label,
  required,
  ...props
}) => {
  const [ isLoading, setIsLoading ] = useState(true)
  const [ brands, setBrands ]       = useState([])

  const fetchBrands = () => {
    CustomerProductsBrandsApi.get({
      additionalFilters: {
        sort_by        : 'name',
        status         : 'enabled',
        classification : 'fastsell'
      }
    }).then((response) => {
      const mappedResponse = response.map((brand) => ({
        ...brand,
        value: brand.id
      }))
      setBrands(mappedResponse)
    }).catch((error) => alert(error.message))
      .finally(() => setIsLoading(false))
  }

  useEffect(() => {
    fetchBrands()
  }, [ ])

  return (
    <ReactSelectSearchField
      name={ name }
      label={ label }
      required={ required }
      dataList={ brands }
      isLoading={ isLoading }
      isClearable={ true }
      { ...props }
    />
  )
}

FastSellProductBrandSelectField.propTypes    = propTypes
FastSellProductBrandSelectField.defaultProps = defaultProps

export default FastSellProductBrandSelectField